import React, { useContext, useEffect } from 'react';
import LanguageBarItem from 'components/LanguageBarItem/LanguageBarItem';
import { IWordingsContext, WordingsContext } from '../../wordingsState/wordingsContext';
import { trueOrderLanguageIDs } from 'appConstants';
import style from './LanguageBar.module.scss';

export const LanguageBar: React.FC = () => {
	const { setLanguage, availableLanguages, selectedLanguage } = useContext<IWordingsContext>(WordingsContext);

	const getTrueLanguagesOrder = () => {
		const languages = [...availableLanguages];
		const sortByObject: { [key: string]: number } = trueOrderLanguageIDs.reduce((obj, item, index) => {
			return {
				...obj,
				[item]: index,
			};
		}, {});
		languages.sort((a, b) => sortByObject[a.id] - sortByObject[b.id]);
		return languages;
	};

	const sortedLanguages = getTrueLanguagesOrder();

	useEffect(() => {
		const defaultValue = sortedLanguages.length
			? { id: sortedLanguages[0].id, name: sortedLanguages[0].name }
			: { id: '', name: '' };
		setLanguage(defaultValue);
	}, [sortedLanguages.length]);

	return (
		<>
			{availableLanguages.length ? (
				<div className={style.container} data-test="LanguageBar">
					{sortedLanguages.map((el) => (
						<LanguageBarItem
							key={el.id}
							languageId={el.id}
							isActive={selectedLanguage?.id === el.id}
							onClick={() => setLanguage({ id: el.id, name: el.name })}
						/>
					))}
				</div>
			) : null}
		</>
	);
};
